module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"et":{"Timezone":"Ajatsoon","Load more timezones":"Lae rohkem ajatsoone"}}')
  delete Component.options._Ctor
}
